export default __webpack_public_path__ + "static/media/double-line-blackboard.0b87aa9d.png";